/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:47
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-23 15:55:10
 * @FilePath: \hlweb2.0\src\components\FreeTrial\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState } from "react";
import { Button } from "antd";
import {JumpApply } from "../Jump";
import { useTranslation } from "react-i18next";
import "./index.scss";
const FreeTrial = () => {
    const { t } = useTranslation();
  return (
    <div className="freeTrial">
      <div className="freeTrial_con">
        <div className="freeTrial_title">{t("navigation.experience_con")}</div>
        {/* <div className="freeTrial_title_con">
          您可以点击在线体验申请，我们将第一时间联系您，并推荐适合您需求的产品，或指派专业的销售顾问为您定制解决方案。
        </div> */}
        <div className="freeTrial_btn">
          <JumpApply/>
        </div>
      </div>
    </div>
  );
};

export default FreeTrial;
